import React, { Component } from 'react';
import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import FullScreenLoader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component
import Button from 'react-toolbox/lib/button';
import Error from 'components/ErrorMessage';// to display error messages on invalid user input
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import styles from './Reset.scss';// to import local scss fle


class Reset extends Component {
  static propTypes = {
    changePassword: PropTypes.func,
    saved: PropTypes.bool,
    requested: PropTypes.bool,
    error: PropTypes.bool,
  };
  static defaultProps = {
    changePassword: () => {},
    saved: false,
    requested: false,
    error: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      reEnterNewPasswordError: '',
      newPasswordErrorMessage: '',
      currentPasswordErrorMessage: '',
      newPassword: '',
      verifyNewPassword: '',
      currentPassword: '',
      password: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.removeErrorMessage = this.removeErrorMessage.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.error !== nextProps.error) {
      this.setState({ currentPasswordErrorMessage: 'Current password did not match!' });
    }
  }
  handleChange(name, value) {
    this.setState({ ...this.state, [name]: value });
  }
  removeErrorMessage(name) {
    this.setState({ ...this.state, [name]: '' });
  }

  validateInput() {
    let validCurrentPassword = false;
    let validNewPassword = false;
    let validReenteredpassword = false;
    const updated = {};
    if (this.state.currentPassword !== '') {
      validCurrentPassword = true;
    } else {
      updated.currentPasswordErrorMessage = 'Enter a valid current password.';
    }
    if (this.state.newPassword !== '') {
      validNewPassword = true;
    } else {
      updated.newPasswordErrorMessage = 'Enter a valid new password.';
    }
    if (this.state.verifyNewPassword !== '' && this.state.newPassword === this.state.verifyNewPassword) {
      validReenteredpassword = true;
    } else {
      updated.reEnterNewPasswordError = 'Password does not match.';
    }
    this.setState(updated, () => {
      if (validReenteredpassword && validNewPassword && validCurrentPassword) {
        this.props.changePassword(this.state.currentPassword, this.state.newPassword);
      }
    });
  }

  render() {
    const renderModifyPassword = renderIf(!this.props.saved);
    const sucessMessage = renderIf(this.props.saved);
    const renderLoader = renderIf(this.props.requested);
    const { reEnterNewPasswordError, currentPassword, newPassword,
         currentPasswordErrorMessage, newPasswordErrorMessage, verifyNewPassword } = this.state;
    return (
      <div className={cn('col row')}>
        {renderLoader(
          <FullScreenLoader />,
          )}
        {sucessMessage(
          <div className={cn('col s12')}>
                  Password updated Sucessfully.
              </div>,

          )}
        {renderModifyPassword(
          <div className={cn('col s12 m6')}>
            <div className={currentPasswordErrorMessage === '' ? cn('col s12', styles.halfWidthWithSpan) : cn('col s12', styles.halfWidthWithSpanError)}>
              <span>OLD PASSWORD</span>
              <Input
                type="password"
                name="current_password"
                value={currentPassword}
                onFocus={() => this.removeErrorMessage('currentPasswordErrorMessage')}
                onChange={val => this.handleChange('currentPassword', val)}
              />
              <Error message={this.state.currentPasswordErrorMessage} />
            </div>
            <div className={newPasswordErrorMessage === '' ? cn('col s12', styles.halfWidthWithSpan) : cn('col s12', styles.halfWidthWithSpanError)}>
              <span>NEW PASSWORD</span>
              <Input
                type="password"
                name="new_password"
                value={newPassword}
                onFocus={() => this.removeErrorMessage('newPasswordErrorMessage')}
                onChange={val => this.handleChange('newPassword', val)}
              />
              <Error message={this.state.newPasswordErrorMessage} />
            </div>
            <div className={reEnterNewPasswordError === '' ? cn('col s12', styles.halfWidthWithSpan) : cn('col s12', styles.halfWidthWithSpanError)}>
              <span>RE-ENTER PASSWORD</span>
              <Input
                type="password"
                name="re-enter-password"
                value={verifyNewPassword}
                onFocus={() => this.removeErrorMessage('reEnterNewPasswordError')}
                onChange={val => this.handleChange('verifyNewPassword', val)}
              />
              <Error message={this.state.reEnterNewPasswordError} />
            </div>
            <Button className={cn('col s12', styles.continue)} onClick={this.validateInput}>SAVE CHANGES</Button>
          </div>,
          )}
      </div>
    );
  }
}

export default Reset;



// WEBPACK FOOTER //
// ./src/components/ResetPassword/Reset.js